import React from 'react';
import { ProfilePicture } from '../../../components/User/ProfilePicture';
import { Stack, Surface } from '../../../styles/Containers';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
export const TeamMate = ({ user, onClick }) => {
    const role = (user?.role === 'editor') ? 'collaborator' : user.role; // CAPTURE COLLAB calls editors Collaborators.
    return (
        <Surface border clickable width="100%" flex align="center" justify="center" direction="column" textAlign="center" onClick={() => onClick(user)}>

            <ProfilePicture user={user} />

            <br />
            <StyledP><StyledB>{user?.firstName} {user?.lastName}</StyledB></StyledP>
            <StyledP light>{role}</StyledP>

        </Surface>
    )
}